import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import PanThumb from '@/components/PanThumb/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { getAdminById } from '@/api/admins';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.userData = {};
  }
  activated() {
    this.fetchData(AdminModule.id);
  }
  async fetchData(id) {
    try {
      const data = await getAdminById(id);
      this.userData = data;
    } catch (err) {} // eslint-disable-line  no-empty
  }
};
__decorate([Prop({
  required: true
})], default_1.prototype, "user", void 0);
default_1 = __decorate([Component({
  name: 'UserCard',
  components: {
    PanThumb
  }
})], default_1);
export default default_1;